/**
 * Income year requirements for postnup financial disclosures.
 *
 * Shared between the API (FD approval completeness checks) and the web app
 * (UI prompts for missing income years). The functions here operate purely
 * on a list of income records and intentionally do not know about document
 * state (finalized/reviewed) or two-party ownership — callers layer those
 * concerns on top.
 */

export function getRequiredIncomeYears(): number[] {
  const currentYear = new Date().getFullYear();
  return [currentYear, currentYear - 1, currentYear - 2];
}

export function getMissingIncomeYears(
  incomes: readonly { readonly year: number | null }[],
): number[] {
  const existingYears = new Set(
    incomes
      .map((income) => income.year)
      .filter((year): year is number => year !== null),
  );
  return getRequiredIncomeYears().filter((year) => !existingYears.has(year));
}

export function hasAllRequiredIncomeYears(
  incomes: readonly { readonly year: number | null }[],
): boolean {
  return getMissingIncomeYears(incomes).length === 0;
}
